module.exports = __webpack_public_path__ + "static/media/kidgames-card.995902a2.svg";